export const SET_LIST_USERS = 'users/SET_LIST_USERS';
export const ADD_USER = 'users/ADD_USER';
export const GET_USER = 'users/GET_USER';
export const SET_USER = 'users/SET_USER';
export const GET_LIST_USERS = 'users/GET_LIST_USERS';
export const EDIT_USER = 'users/EDIT_USER';
export const GET_USER_PERMISSION = 'users/GET_USER_PERMISSION';
export const SET_USER_PERMISSION = 'users/SET_USER_PERMISSION';
export const ACTIVE_DESACTIVE_USER = 'users/ACTIVE_DESACTIVE_USER';
export const SET_USER_REFRESH = 'users/SET_USER_REFRESH';
export const UPDATE_USER_PERMISSION = 'users/UPDATE_USER_PERMISSION';
export const CHANGE_PASSWORD = 'users/CHANGE_PASSWORD';
export const EDIT_USER_PROFILE = 'users/EDIT_USER_PROFILE';
export const GET_USERS_FILTER_BY_LOGGED = 'users/GET_USERS_FILTER_BY_LOGGED';
export const SET_COLLABORATORS = 'users/SET_COLLABORATORS';
export const GET_COORDINATORS = 'users/GET_COORDINATORS';
export const SET_COORDINATORS = 'users/SET_COORDINATORS';
export const SET_IS_REPRESENTATIVE = 'users/SET_IS_REPRESENTATIVE';
export const UPLOAD_IMG = 'users/UPLOAD_IMG';

export default {
	SET_LIST_USERS,
	ADD_USER,
	GET_USER,
	SET_USER,
	GET_LIST_USERS,
	EDIT_USER,
	GET_USER_PERMISSION,
	SET_USER_PERMISSION,
	ACTIVE_DESACTIVE_USER,
	SET_USER_REFRESH,
	UPDATE_USER_PERMISSION,
	CHANGE_PASSWORD,
	EDIT_USER_PROFILE,
	GET_USERS_FILTER_BY_LOGGED,
	SET_COLLABORATORS,
	GET_COORDINATORS,
	SET_COORDINATORS,
	SET_IS_REPRESENTATIVE,
	UPLOAD_IMG
};
